<div class="grid md:grid-cols-2 lg:grid-cols-3 gap-4 m-4">

    <!-- Contact cards -->
    <mat-card *ngFor="let c of contacts$ | async" appearance="outlined" class="!p-2 card">

        <mat-card-header class="justify-between items-center">
            <mat-card-title>
                {{ c.first  + ' ' + c.last }}
                <mat-chip *ngIf="!!c.isPrimary" class="ml-2 !rounded-full !h-6 !bg-lendio-teal-500">Primary</mat-chip>
            </mat-card-title>
            <button *ngIf="_hasModifyAccess(business$ | async)" class="edit-button" (click)="openEditDialog(c)">
                <mat-icon class="material-symbols-outlined">edit</mat-icon>
            </button>
        </mat-card-header>
        <div class="lendio-mat-card-divider"></div>
        <mat-card-content>
            <div class="flex">
                <table class="grow table table-auto">
                    <tr class="table-row">
                        <td class="label">Email</td>
                        <td class="value">
                            <span>{{ c.email }}</span>
                        </td>
                    </tr>
                    <tr class="table-row">
                        <td class="label">Mobile phone</td>
                        <td class="value">
                            <span>{{ c.mobilePhone | phone }}</span>
                        </td>
                    </tr>
                    <tr class="table-row">
                        <td class="label">Work phone</td>
                        <td class="value">
                            <span>{{ c.workPhone | phone }}</span>
                            <span *ngIf="c.workPhoneExt"> ext. {{ c.workPhoneExt }}</span>
                        </td>
                    </tr>
                    <tr class="table-row">
                        <td class="label">Birth-date</td>
                        <td class="value">
                            <span>{{ c.birthDate | date }}</span>
                        </td>
                    </tr>
                    <tr class="table-row">
                        <td class="label">Social security</td>
                        <td class="value">
                            <span *ngIf="c.ssnLastFour">xxx-xx-{{ c.ssnLastFour }}</span>
                        </td>
                    </tr>
                    <tr class="table-row">
                        <td class="label">Owner?</td>
                        <td class="value">
                            <span>{{ c.percentOwnership ? 'Yes' : 'No' }}</span>
                        </td>
                    </tr>
                    <tr class="table-row">
                        <td class="label">Ownership %</td>
                        <td class="value">
                            <span>{{ c.percentOwnership }}</span>
                        </td>
                    </tr>
                    <tr class="table-row">
                        <td class="label">Job title</td>
                        <td class="value">
                            <span>{{ c.title }}</span>
                        </td>
                    </tr>
                    <tr class="table-row">
                        <td class="label">Address</td>
                        <td class="value multi-line">
                            <span *ngIf="c?.street">{{ c.street }}<br /></span>
                            <span *ngIf="c?.street2">{{ c.street2 }}<br /></span>
                            <span *ngIf="getCityStateZip(c)">{{ getCityStateZip(c) }}</span>
                        </td>
                    </tr>
                </table>
            </div>
        </mat-card-content>
    </mat-card>
    <!-- Add contact card -->
    <mat-card *ngIf="_hasModifyAccess(business$ | async)" appearance="outlined" class="add-contact" (click)="openEditDialog()">
        <div class="card grow p-2 grid justify-center content-center" data-cy="business-details-add-contact">
            <div class="flex">
                <mat-icon>add</mat-icon>
                &nbsp;&nbsp;Add contact
            </div>
        </div>
    </mat-card>

</div>
